const SectionHeader = ({ eyebrow, title, description, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-[#0BBF64]">
        {eyebrow}
      </p>
    )}
    <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
      {title}
    </h2>
    {description && (
      <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-600">
        {description}
      </p>
    )}
  </div>
);

export default SectionHeader;
